"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestedBy = void 0;
exports.instanceOfRequestedBy = instanceOfRequestedBy;
exports.RequestedByFromJSON = RequestedByFromJSON;
exports.RequestedByFromJSONTyped = RequestedByFromJSONTyped;
exports.RequestedByToJSON = RequestedByToJSON;
exports.RequestedByToJSONTyped = RequestedByToJSONTyped;
/**
 *
 * @export
 */
exports.RequestedBy = {
    Nurse: 'NURSE',
    Facility: 'FACILITY'
};
function instanceOfRequestedBy(value) {
    for (const key in exports.RequestedBy) {
        if (Object.prototype.hasOwnProperty.call(exports.RequestedBy, key)) {
            if (exports.RequestedBy[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function RequestedByFromJSON(json) {
    return RequestedByFromJSONTyped(json, false);
}
function RequestedByFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function RequestedByToJSON(value) {
    return value;
}
function RequestedByToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=RequestedBy.js.map